import React, { lazy, Suspense } from 'react';
import { useOnboarding } from '../../context/OnboardingContext';
import OnboardingWizard from './OnboardingWizard';

const ProductTour = lazy(() => import('./ProductTour'));

interface OnboardingWrapperProps {
  children: React.ReactNode;
}

export default function OnboardingWrapper({ children }: OnboardingWrapperProps) {
  const { showOnboarding, completeOnboarding, skipOnboarding, isTourActive, completeTour, skipTour } = useOnboarding();

  return (
    <>
      {children}
      {showOnboarding && (
        <OnboardingWizard
          onComplete={completeOnboarding}
          onSkip={skipOnboarding}
        />
      )}
      {isTourActive && (
        <Suspense fallback={null}>
          <ProductTour run={isTourActive} onComplete={completeTour} onSkip={skipTour} />
        </Suspense>
      )}
    </>
  );
}